import { NgModule } from '@angular/core';

import { WindowModule } from '@pe/checkout/window';

import { SnackBarShowerComponent } from './components';
import { PluginEventsService } from './services/plugin-events.service';

@NgModule({
  imports: [
    WindowModule,
  ],
  declarations: [
    SnackBarShowerComponent,
  ],
  exports: [
    SnackBarShowerComponent,
  ],
  providers: [
    PluginEventsService,
  ],
})
export class PluginsModule {
}
